// Tokenize complete start tags, including all quoted values, so anchor-like
// text inside another tag's attributes never gets treated as markup.
const HTML_TOKEN =
  /<!--[\s\S]*?-->|<(script|style|textarea|title|xmp|iframe|noembed|noframes|noscript)\b(?:[^"'>]|"[^"]*"|'[^']*')*>[\s\S]*?<\/\1\s*>|<[a-z][\w:-]*\b(?:[^"'>]|"[^"]*"|'[^']*')*>/gi

export interface HtmlAttribute {
  name: string
  value: string
  start: number
  end: number
}

export const anchorAttributes = (tag: string): HtmlAttribute[] => {
  const attributes: HtmlAttribute[] = []
  const token = /\s+([^\s"'<>/=]+)(?:\s*=\s*(?:"([^"]*)"|'([^']*)'|([^\s>]+)))?/y
  let offset = 2
  while (offset < tag.length) {
    token.lastIndex = offset
    const match = token.exec(tag)
    if (!match) break
    attributes.push({
      name: match[1].toLowerCase(),
      value: match[2] ?? match[3] ?? match[4] ?? '',
      start: offset,
      end: token.lastIndex,
    })
    offset = token.lastIndex
  }
  return attributes
}

export const mapHtmlAnchors = (html: string, visit: (tag: string) => string): string =>
  html.replace(HTML_TOKEN, (tag) => (/^<a(?=\s|\/?>)/i.test(tag) ? visit(tag) : tag))

export const someHtmlAnchor = (html: string, predicate: (tag: string) => boolean): boolean => {
  for (const [tag] of html.matchAll(HTML_TOKEN)) {
    if (/^<a(?=\s|\/?>)/i.test(tag) && predicate(tag)) return true
  }
  return false
}
